import { useLoadScript } from './useLoadScript'

export const useTrustArc = (shouldLoadScript: boolean, IsEU: boolean, isLogMeInDomain: boolean, language?: string) => {
    let domain = 'goto'

    if (isLogMeInDomain) {
        domain = 'logmein'
    }

    return useLoadScript(
        `//consent.trustarc.com/notice?domain=${domain}.com&gtm=1&c=teconsent&js=nj&noticeType=bb&text=true&pcookie${
            !IsEU ? '&oc=1' : ''
        }`,
        shouldLoadScript,
        language
    )
}
